import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";
import DOMPurify from "isomorphic-dompurify";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductPolicyModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  cta: {
    type: String,
    required: true,
  },
  body: {
    type: String,
    required: true,
  },
},
  emits: ["open-modal-click"],
  setup(__props, { emit }: { emit: ({
  (e: "open-modal-click"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const sanitizedBody = computed(() => DOMPurify.sanitize(props.body));

function onClick() {
  emit("open-modal-click");
}

return { __sfc: true,props, emit, sanitizedBody, onClick }
}

})